<div class="flex flex-col gap-8 text-gray-black">
  <!-- Search input - sempre visibile -->
  <div class="flex flex-row items-center !w-full sm:w-auto sm:min-w-[200px]">
    <ape-input
      [cssClassInputWrapper]="'!w-full'"
      class="!w-full"
      [showLabelText]="false"
      [cssClass]="'!h-[46px] !w-full'"
      [value]="localSearchValue"
      (valueChange)="onSearchChange($event)"
      (onKeyUp)="onSearchKeyUp($event)"
      [placeholder]="TRANSLATION_KEYS.admin.impersonate.SEARCH_PLACEHOLDER | translate"
    />
    <div
      tabindex="0"
      role="button"
      (click)="performSearch()"
      class="rounded-[0px_3px_3px_0px] h-[46px] w-[46px] text-base font-medium bg-black text-white p-[11px] flex flex-row items-center flex-shrink-0 cursor-pointer"
      [attr.aria-label]="TRANSLATION_KEYS.admin.impersonate.SEARCH_PLACEHOLDER | translate"
    >
      <svg-icon
        name="search"
        class="w-[24px] h-[24px]"
        src="assets/icons/search.svg"
        [attr.aria-hidden]="true"
      />
    </div>
  </div>

  <div class="flex flex-col gap-2">
    <!-- Border e conteggio risultati - sempre visibili -->
    <div class="w-full h-[1px] bg-[#EEEEEE]"></div>
    <div class="py-3 text-sm text-gray-600">
      <ng-container *ngIf="totalItems === 1">
        <strong class="font-bold">1</strong> {{ TRANSLATION_KEYS.generic.feedback.filters.results.RESULT | translate }}
      </ng-container>
      <ng-container *ngIf="totalItems !== 1">
        <strong class="font-bold">{{ totalItems }}</strong> {{ TRANSLATION_KEYS.generic.feedback.filters.results.RESULTS
        | translate }}
      </ng-container>
    </div>
  </div>

  <!-- Users table e paginazione - visibili solo se ci sono risultati -->
  <ng-container *ngIf="users.length > 0">
    <!-- Users table -->
    <p-table
      [value]="users"
      [scrollable]="true"
      scrollDirection="horizontal"
      [tableStyle]="{ 'min-width': '60rem' }"
    >
      <ng-template #header>
        <tr>
          <th
            class="!p-4"
            apeResponsiveFrozen
            style="min-width: 200px;"
          >
            <span class="font-bold text-[#020617]">
              {{ TRANSLATION_KEYS.admin.impersonate.TABLE.FULL_NAME | translate }}
            </span>
          </th>
          <th class="!p-4">
            <span class="font-bold text-[#020617]">
              {{ TRANSLATION_KEYS.admin.impersonate.TABLE.TAX_CODE | translate }}
            </span>
          </th>
          <th class="!p-4">
            <span class="font-bold text-[#020617]">
              {{ TRANSLATION_KEYS.admin.impersonate.TABLE.EMAIL | translate }}
            </span>
          </th>
          <th class="!p-4">
            <span class="font-bold text-[#020617]">
              {{ TRANSLATION_KEYS.admin.impersonate.TABLE.COMPANY | translate }}
            </span>
          </th>
          <th class="!p-4">
            <span class="font-bold text-[#020617]">
              {{ TRANSLATION_KEYS.admin.impersonate.TABLE.MANAGER | translate }}
            </span>
          </th>
          <th
            pFrozenColumn
            alignFrozen="right"
            style="width: 87px;"
            class="relative text-center p-4 font-bold"
          >
            {{ TRANSLATION_KEYS.admin.impersonate.TABLE.ACTIONS | translate }}
          </th>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-user
      >
        <tr>
          <td
            apeResponsiveFrozen
            style="min-width: 200px;"
            class="!px-4 !py-3.5"
          >
            <div class="flex flex-row items-center gap-[10px]">
              <ape-avatar
                [image]="user.avatarImage"
                [forename]="user.forename"
                [surname]="user.surname"
                size="medium"
                shape="square"
                [attr.aria-hidden]="true"
                [withRing]="false"
                [variant]="'simple'"
              />
              <span>
                {{ user.surname + " " + user.forename }}
              </span>
            </div>
          </td>
          <td class="!px-4 !py-3.5">
            <span>
              {{ user.taxId }}
            </span>
          </td>
          <td class="!px-4 !py-3.5">
            <div
              class="font-normal text-[#000] cursor-pointer hover:text-shadow-theme-link truncate max-w-[200px]"
              [pTooltip]="user.email"
              tooltipPosition="top"
              (click)="copyEmail(user.email)"
              (keydown.enter)="copyEmail(user.email)"
              tabindex="0"
              role="button"
              [attr.aria-label]="(TRANSLATION_KEYS.admin.impersonate.TABLE.COPY_EMAIL | translate) + ': ' + user.email"
              [class.text-green-600]="isEmailCopied(user.email)"
            >
              {{ isEmailCopied(user.email) ? (TRANSLATION_KEYS.admin.impersonate.TABLE.EMAIL_COPIED | translate) :
              user.email }}
            </div>
          </td>
          <td class="!px-4 !py-3.5">
            <span>
              {{ user.company }}
            </span>
          </td>
          <td class="!px-4 !py-3.5">
            <span>
              {{ user.managerSurname + " " + user.managerForename }}
            </span>
          </td>
          <td
            class="relative !text-center"
            pFrozenColumn
            alignFrozen="right"
            style="width: 87px;"
          >
            <ape-button
              [id]="'action-user-button-'
            +
            user.userId"
              class="my-0 mx-auto !w-8 !h-8"
              [cssClass]="'!w-8 !h-8'"
              size="small"
              aspect="icon"
              variant="primary"
              [rightIcon]="'assets/icons/ellipsis.svg'"
              [ariaLabel]="TRANSLATION_KEYS.admin.impersonate.TABLE.ACTIONS | translate"
              (buttonClick)="toggleActionMenu(user, $event)"
              [disabled]="!canToggleActionMenu(user)"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginazione sotto la tabella -->
    <ape-table-pagination
      [total]="totalPages"
      [page]="page"
      [pageSize]="pageSize"
      [dropdownUp]="true"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      [pageSizeOptions]="pageSizeOptions"
      [selectedPageSize]="selectedPageSize"
    />
  </ng-container>

  <!-- Placeholder quando non ci sono risultati - visibile solo se non ci sono utenti -->
  <ape-admin-impersonate-placeholder *ngIf="users.length === 0" />

  <!-- Menu a tendina per le azioni -->
  <ape-menu
    #apeMenu
    [menuItems]="menuItems"
  />
</div>